<p-toast></p-toast>
<form [formGroup]="form" class="p-fluid">
  <hr class="mt-0 mb-4" />  
   <div class="p-4">
 <div class="flex flex-column gap-2 mb-4">
  <!-- Start Date -->
  <div class="field grid">
    <label for="startDate" class="col-12 md:col-4 font-medium">
      {{ 'layout.configurations.currencies.startDate' | translate }}
      <span class="text-red-500">*</span>
    </label>

    <div class="col-12 md:col-8">
      <p-calendar
        id="startDate"
        formControlName="startDate"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        appendTo="body"
        class="w-full">
      </p-calendar>

      <small
        class="text-red-500"
        *ngIf="form.get('startDate')?.touched && form.get('startDate')?.hasError('required')">
        {{ 'layout.configurations.currencies.startDateRequired' | translate }}
      </small>
    </div>
  </div>

  <!-- End Date -->
  <div class="field grid">
    <label for="endDate" class="col-12 md:col-4 font-medium">
      {{ 'layout.configurations.currencies.endDate' | translate }}
    </label>

    <div class="col-12 md:col-8">
      <p-calendar
        id="endDate"
        formControlName="endDate"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        appendTo="body"
        class="w-full">
      </p-calendar>
      <small
        class="text-red-500"
        *ngIf="dateRangeError">
        {{ dateRangeError | translate }}
      </small>
    </div>
  </div>

  <!-- Rates -->
  <div formArrayName="rates" class="mt-4">
    <div
      *ngFor="let r of rates.controls; let i = index"
      [formGroupName]="i"
      class="field grid align-items-center">

      <label class="col-12 md:col-4 font-medium">
        {{ r.value.currency }}
      </label>

      <div class="col-12 md:col-8">
        <input
          pInputText
          type="number"
          formControlName="exchangeRate"
          class="w-full"
          [placeholder]="'layout.configurations.currencies.enterRateExchange' | translate" />
        <small
          class="text-red-500"
          *ngIf="isRateInvalid(i).invalid">
          {{ (isRateInvalid(i).message || '') | translate }}
        </small>
      </div>
    </div>
  </div></div>

  <!-- Buttons -->
  <div class="flex justify-content-end gap-2 mt-4">
    <p-button
    [label]="(isEditMode ? 'layout.configurations.currencies.updateRate' : 'layout.configurations.currencies.addCurrency.saveRate')| translate"
      icon="pi pi-check"
      type="button"
      (onClick)="saveRate()">
    </p-button>
    <p-button
      [label]="'layout.configurations.currencies.cancelRate' | translate"
      icon="pi pi-times"
      class="p-button-outlined"
      severity="danger"
      (onClick)="onCancel()">
    </p-button>
  </div>
  </div>
</form>